import { Box, Container } from "@mui/material";
import React, { useEffect, useState } from "react";
import BackBtn from "../../widgets/BackBtn";
import PageTitle from "../../widgets/PageTitle";
import CustomTabs from "../../widgets/CustomTabs";
import SmartButtonIcon from "@mui/icons-material/SmartButton";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
import MessageIcon from "@mui/icons-material/Message";
import ListButtons from "./ListButtons";
import ListMessages from "./ListMessages";
import { useLocation, useNavigate } from "react-router-dom";
const ChainReplyBuilder = () => {
  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const pid = query.get("p");
  const [replyGroup, setReplyGroup] = useState(0);
  useEffect(() => {
    if (pid && Number(pid) !== replyGroup) {
      setReplyGroup(Number(pid));
    }
  }, [pid, replyGroup]);
  return (
    <Container maxWidth="md" sx={{ mt: 3 }}>
      <PageTitle mb={2}>Chatbot Builder</PageTitle>
      <Box>
        <CustomTabs
          tabs={[
            {
              label: "Message",
              icon: (
                <MessageIcon fontSize="small" sx={{ transition: "all 0.3s" }} />
              ),
            },
            {
              label: "Buttons",
              icon: (
                <SmartButtonIcon
                  fontSize="small"
                  sx={{ transition: "all 0.3s" }}
                />
              ),
            },
            {
              label: "Texts",
              icon: (
                <FormatColorTextIcon
                  fontSize="small"
                  sx={{ transition: "all 0.3s" }}
                />
              ),
            },
          ]}
          value={replyGroup}
          onChange={(e, newValue) => {
            navigate(`/home/chain-reply-builder?p=${newValue}`);
          }}
          containerSx={{ width: "100%", mt: 1 }}
        />
        <Box mt={2}>
          {replyGroup === 0 && <ListMessages />}
          {replyGroup === 1 && <ListButtons type="button" />}
          {replyGroup === 2 && <ListButtons type="text" />}
        </Box>
      </Box>
    </Container>
  );
};

export default ChainReplyBuilder;
